'use strict';

var productItem = require('../helpers/productItem');

var currentBasketInfo;

/**
 * Measure products added to the cart using an 'add_to_cart' actionFieldObject
 * and a list of productFieldObjects.
 *
 * @param {Object} productData An object representing a product.
 * @param {array} dataLayer
 */
function piwikTriggerAddToCartEvent(productData, dataLayer) {
    try {
        var data = {
            event: 'add_to_cart',
            ecommerce: {
                currency: productData.currencyCode,
                value: Number(parseFloat(productData.priceTotal).toFixed(2)),
                items: productData.products.map(function (product) {
                    return productItem.productFormatted(product);
                })
            }
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
    } catch (e) {
        console.error('Piwik Analytics: Error in piwikTriggerAddToCartEvent:', e);
    }
}

/**
 * Measure products removed from the cart using an 'remove_from_cart' actionFieldObject
 * and a list of productFieldObjects.
 *
 * @param {Object} productData An object representing a product.
 * @param {array} dataLayer
 */
function piwikTriggerRemoveFromCartEvent(productData, dataLayer) {
    try {
        var data = {
            event: 'remove_from_cart',
            ecommerce: {
                currency: productData.currencyCode,
                value: Number(parseFloat(productData.priceTotal).toFixed(2)),
                items: productData.products.map(function (product) {
                    return productItem.productFormatted(product);
                })
            }
        };

        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
    } catch (e) {
        console.error('Piwik Analytics: Error in piwikTriggerRemoveFromCartEvent:', e);
    }
}

/**
 * Create a product line item object formatted for Piwik Analytics from the product line item object.
 *
 * @param {Object} pli - Product line item object.
 * @returns {Object} A formatted product line object for Piwik Analytics
 */
function createPLIObject(pli) {
    if (pli) {
        try {
            var productLineObj = {
                currencyCode: pli.price.sales.currency,
                priceTotal: pli.price.sales.value,
                products: [
                    {
                        id: pli.id,
                        name: pli.productName,
                        price: pli.price.sales.value,
                        brand: pli.brand,
                        qty: pli.quantity,
                        categoryPath: pli.productCategoryPath,
                        is_subscribed: pli.isSubscription
                    }
                ]
            };

            if (pli.appliedPromotions && pli.appliedPromotions.length > 0) {
                var product = productLineObj.products[0];
                var promotion = pli.appliedPromotions[0];
                product.discount =
                    pli.price.list && pli.price.list.value ? pli.price.list.value - pli.price.sales.value : null;
                product.promotionId = promotion.id;
                product.promotionName = promotion.name;
                product.couponCode = pli.appliedCouponCode ? pli.appliedCouponCode : null;
            }

            return productLineObj;
        } catch (e) {
            return {};
        }
    }
    return {};
}

/**
 * Updates the `currentBasketInfo` variable  based on the contents of the cart.
 * These values are used to build an array of objects with `productId` as key  and the rest of properties as value.
 *
 * @param {Object} cartItems - The product items included in the basket.
 * @returns {void}
 */
function updateCurrentBasketInfo(cartItems) {
    currentBasketInfo = {};

    if (cartItems && cartItems.length > 0) {
        cartItems.forEach(function (item) {
            currentBasketInfo[item.id] = createPLIObject(item);
        });
    }
}

/**
 * Compares the `currentBasketInfo` variable with the new basket info
 * and triggers a Piwik Analytic Event depending on the differences.
 *
 * @param {Object} cartItems - The product items included in the basket after being updated.
 * @returns {void}
 */
function getBasketUpdates(cartItems) {
    var productAdded = null;
    var productRemoved = null;
    var numTriggerEvent = 0;
    var cartMap = {};

    cartItems.forEach(function (item) {
        cartMap[item.id] = createPLIObject(item);
    });

    // Check for removed or updated products
    for (var currentProduct in currentBasketInfo) {
        if (!Object.hasOwnProperty.call(cartMap, currentProduct)) {
            numTriggerEvent = currentBasketInfo[currentProduct].products[0].qty;
            productRemoved = currentBasketInfo[currentProduct];
            break;
        } else {
            var currentQty = currentBasketInfo[currentProduct].products[0].qty;
            var newQty = cartMap[currentProduct].products[0].qty;
            if (currentQty !== newQty) {
                numTriggerEvent = Math.abs(newQty - currentQty);
                if (newQty > currentQty) {
                    productAdded = cartMap[currentProduct];
                } else {
                    productRemoved = currentBasketInfo[currentProduct];
                }
                break;
            }
        }
    }

    // Check for added products
    if (!numTriggerEvent) {
        for (var newProduct in cartMap) {
            if (!Object.hasOwnProperty.call(currentBasketInfo, newProduct)) {
                numTriggerEvent = cartMap[newProduct].products[0].qty;
                productAdded = cartMap[newProduct];
                break;
            }
        }
    }

    // Trigger Piwik Events
    if (numTriggerEvent > 0 && (productAdded || productRemoved)) {
        for (var i = 0; i < numTriggerEvent; i++) {
            if (productAdded) {
                productAdded.products[0].qty = 1;
                piwikTriggerAddToCartEvent(productAdded, window.dataLayer || []);
            } else if (productRemoved) {
                productRemoved.products[0].qty = 1;
                piwikTriggerRemoveFromCartEvent(productRemoved, window.dataLayer || []);
            }
        }
    }
}

$(function () {
    $('body').on('cart:beforeUpdate product:beforeAddToCart', function () {
        const url = window.productLineItemsInfoUrl || null;
        if (url) {
            $.ajax({
                type: 'GET',
                url,
                async: false,
                success: (data) => {
                    if (data && data.success && data.products) {
                        updateCurrentBasketInfo(data.products);
                    }
                }
            });
        }
    });

    $('body').on('cart:update product:afterAddToCart', function (e, response) {
        if (
            response &&
            ((response.cart && response.cart.items) || (response.basket && response.basket.items) || response.items)
        ) {
            var basketItems;
            if (response.cart && response.cart.items) {
                basketItems = response.cart.items;
            } else if (response.basket && response.basket.items) {
                basketItems = response.basket.items;
            } else {
                basketItems = response.items;
            }
            getBasketUpdates(basketItems);
            updateCurrentBasketInfo(basketItems);
        }
    });
});
